import { Component, OnInit, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Router } from '@angular/router';
import {
  Cart,
  CartQuery,
  CartService,
  MarketplaceAttributeCartItem,
  MarketplaceItem,
  MarketplaceItemExtended,
  MarketplaceQuery,
} from '@fgb/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'fgbcl-cart-item',
  templateUrl: './cart-item.component.html',
  styleUrls: ['./cart-item.component.scss'],
})
export class CartItemComponent implements OnInit {
  @Input() isCheckoutPage: boolean;
  items$: Observable<Cart[] | undefined>;
  totalItems$: Observable<number>;
  basketPointsTotal$: Observable<number | undefined>;
  marketplaceItems: MarketplaceItem[];
  marketplaceItemCount: number;
  destroyed$ = new Subject<void>();
  constructor(
    private cartQuery: CartQuery,
    private cartService: CartService,
    private router: Router,
    private marketplaceQuery: MarketplaceQuery
  ) {}

  ngOnInit() {
    this.items$ = this.cartQuery.selectAllMarketplaceCartData();
    this.totalItems$ = this.cartQuery.updateTotalItems();
    this.basketPointsTotal$ = this.cartQuery.updateBasketPointsTotal();
    this.marketplaceQuery
      .selectMarketplaceItems()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((marketplaceItems) => (this.marketplaceItems = marketplaceItems));
  }

  remove(itemToRemove: Cart) {
    this.cartService.remove(itemToRemove.id);
  }

  redirectToDetail(id: string) {
    return this.router.navigateByUrl(`/rewards/marketplace/details/${id}`);
  }

  updateCartItemValue(cartItem: Cart, quantity: number) {
    this.cartService.addMarketplaceItemToCart(
      cartItem.productData as MarketplaceItemExtended,
      quantity,
      cartItem.attributes as MarketplaceAttributeCartItem,
      cartItem.customFields,
      true
    );
  }

  // if purchaseMarketplaceItemsInCart in cartService has an error, selectMarketplaceItems will fetch agian to check real stock quantity
  checkQuantityOfCartItem(cartItem: Cart): string {
    const product = cartItem.productData as MarketplaceItemExtended;
    let marketplaceItem = this.marketplaceItems?.find((mpi) => mpi.Id === product.Id);
    this.marketplaceItemCount = marketplaceItem?.AvailabilityCount || 0;
    return cartItem.purchaseQuantity > this.marketplaceItemCount ? 'marketplace.item.count.left' : '';
  }

  identify(index: number, cart: Cart) {
    return cart.id;
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
